import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { TrlStatusText } from '»components/atoms';

import {
  ListItemStyled,
  ListItemTextStyled,
  ListStyled,
} from './TrlListContent.styles';

export const TrlListContent = ({ data, hasMarginBottom, noTopRadius }) => (
  <ListStyled hasMarginBottom={hasMarginBottom}>
    {data.map((item, index) => (
      <ListItemStyled
        key={item.value + item.label}
        disableGutters
        noTopRadius={noTopRadius && index === 0}
      >
        <ListItemTextStyled primary={<FormattedMessage id={item.label} />} />
        <TrlStatusText
          value={item.value}
          type={item.type}
          field={item.field}
          priceRepresentation={item.priceRepresentation}
          currency={item.currency}
          onClick={item.onClick}
          roundPrice={item.roundPrice}
        />
      </ListItemStyled>
    ))}
  </ListStyled>
);

TrlListContent.propTypes = {
  data: PropTypes.array.isRequired,
  hasMarginBottom: PropTypes.bool,
  noTopRadius: PropTypes.bool,
};
